import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/diagnostics/')({
  component: () => <PageStub title="Diagnostics Library" description="Business health assessments" />,
});
